import { render, staticRenderFns } from "./PersonalesGeneral.vue?vue&type=template&id=4e50a604&lang=html&"
import script from "./PersonalesGeneral.vue?vue&type=script&lang=js&"
export * from "./PersonalesGeneral.vue?vue&type=script&lang=js&"
import style0 from "./PersonalesGeneral.vue?vue&type=style&index=0&id=4e50a604&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports